<mat-radio-group
        [ngClass]="{'is-flex-fluid': isFlex}"

        (change)="changeValue($event)"
>
    <mat-radio-button
            *ngFor="let option of asFormsControl().options"
            [value]="option.value"
            [checked]="option.checked"
            [disabled]="option.disabled"
            [color]="option.color || 'primary'"
            class="pr-3"
    >
        <ng-container *ngIf="!hiddenLabel">
            {{option.label}}
        </ng-container>
    </mat-radio-button>
</mat-radio-group>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
